import React from 'react';
import { withNamespaces, Trans } from 'react-i18next';
import { observer } from 'mobx-react';

import { SelectField } from 'libs/forms/views/fieldTypes/select';
import { Dropdown } from 'apps/autocomplete/views/dropdown';
import FormActionButton from 'libs/forms/views/formActionButton';
import { FormWrapper, FormField, Label } from 'libs/forms/styles';

import {
  SettingsSection,
  FullWidthDivider,
  Center,
} from 'legacyComponents/styled/lib';

import { SectionTitle } from 'apps/group/styles';

import { ChangeLanguageAppManager } from 'apps/profile/settings/tabs/account/changeLanguage/appManager';

@withNamespaces()
@observer
export class ChangeLanguage extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new ChangeLanguageAppManager(null, {});
  }

  render() {
    const {
      app: { form },
    } = this.appManager;

    const languageField = form.fieldStores.get('languageSelection');
    const refs = {};

    return (
      <SettingsSection>
        <SectionTitle>
          <Trans>Change Language</Trans>:
        </SectionTitle>
        <FullWidthDivider />
        <FormWrapper
          responsive
          posting={form.posting}
          onSubmit={e => {
            e.preventDefault();
            form.prepare();
            this.appManager.app.Submit();
          }}
        >
          <FormField>
            <Label>
              <Trans>Language</Trans>
            </Label>
            <SelectField
              fieldStore={languageField}
              ref={input => {
                refs[languageField.fieldName] = input;
              }}
              noValidation
              responsive
            />
            <Dropdown
              inputFields={refs}
              fieldName={languageField.fieldName}
              manager={languageField.optionsManager}
            />
          </FormField>

          <Center>
            <FormActionButton
              formStore={form}
              buttonText={form.conf.buttonText}
              buttonTextPosting={form.conf.buttonTextPosting}
              size='small'
              // FIXME: remove this inline style
              style={{ marginTop: '1rem' }}
              outline
            />
          </Center>
        </FormWrapper>
      </SettingsSection>
    );
  }
}
